import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { PorangeButton } from "@/components/atoms/PorangeButton";
import { VETTED_PLACES_WORLDWIDE } from '@/constants';

export const Statement = ({ onAnswer }) => {
    const [showFirstLine, setShowFirstLine] = useState(false);
    const [showSecondLine, setShowSecondLine] = useState(false);
    const [showBubbles, setShowBubbles] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const [isExiting, setIsExiting] = useState(false);
    const [particlesExiting, setParticlesExiting] = useState(false);

    useEffect(() => {
        setTimeout(() => setShowFirstLine(true), 200);
        setTimeout(() => setShowSecondLine(true), 600);
        setTimeout(() => setShowBubbles(true), 400);
        setTimeout(() => setShowButton(true), 1400);
    }, []);

    const handleContinue = () => {
        setParticlesExiting(true);
        setShowButton(false);
        setTimeout(() => {
            setIsExiting(true);
            setTimeout(() => onAnswer('continue'), 800);
        }, 400);
    };

    return (
        <div className={classNames(
            "relative h-full flex flex-col items-center justify-start px-6",
            isExiting ? "opacity-0" : "opacity-100"
        )}>
            <div className="text-center space-y-4 max-w-[600px] mt-[48px]">
                <div className="overflow-hidden">
                    <h2
                        className={classNames(
                            "text-[32px] md:text-[40px] leading-tight font-bold transition-all duration-500 text-black",
                            showFirstLine ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full"
                        )}
                    >
                        Our Gluten Free map has over{' '}
                        <span className="animate-shimmer bg-[length:200%_100%] bg-clip-text text-transparent bg-gradient-to-r from-pink-500 via-orange-500 to-pink-500">
                            {VETTED_PLACES_WORLDWIDE} gluten-free places
                        </span>{' '}
                        worldwide
                    </h2>
                </div>

                <div className="overflow-hidden">
                    <h3
                        className={classNames(
                            "text-xl md:text-2xl text-gray-600 transition-all duration-500",
                            showSecondLine ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full"
                        )}
                    >
                        Finding places is a breeze
                    </h3>
                </div>
            </div>

            {showBubbles && (
                <div
                    className={classNames(
                        "absolute overflow-hidden pointer-events-none transition-all duration-500",
                        particlesExiting ? "opacity-0" : "opacity-100"
                    )}
                    style={{
                        top: '30%',
                        left: 0,
                        right: 0,
                        bottom: '80px',
                    }}
                >
                    {[...Array(70)].map((_, i) => (
                        <div
                            key={i}
                            className="absolute pointer-events-none"
                            style={{
                                left: `${-50 - (Math.random() * 50)}px`,
                                top: `${Math.random() * 300}%`,
                                animation: `breezePath 8s linear infinite`,
                                animationDelay: `${Math.random() * 8}s`,
                                opacity: 0,
                            }}
                        >
                            <div
                                className="rounded-full bg-gradient-to-tr from-pink-500/20 to-orange-500/20 animate-pulse"
                                style={{
                                    width: `${15 + Math.random() * 30}px`,
                                    height: `${15 + Math.random() * 30}px`,
                                    animation: `spin ${3 + Math.random() * 2}s linear infinite`,
                                }}
                            />
                        </div>
                    ))}
                </div>
            )}

            <div
                className={classNames(
                    "fixed bottom-0 left-0 right-0 p-5 transition-all duration-500 bg-gradient-to-t from-white via-white to-transparent pb-6 pt-10",
                    showButton ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8 pointer-events-none"
                )}
            >
                <PorangeButton
                    full={true}
                    className="h-[56px] rounded-[16px] text-lg shadow-md"
                    onClick={handleContinue}
                >
                    Continue
                </PorangeButton>
            </div>

            <style jsx global>{`
                @keyframes breezePath {
                    0% {
                        transform: translateX(0);
                        opacity: 0;
                    }
                    5% {
                        opacity: 0.8;
                    }
                    95% {
                        opacity: 0.8;
                    }
                    100% {
                        transform: translateX(calc(100vw + 100px));
                        opacity: 0;
                    }
                }

                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }

                @keyframes shimmer {
                    0% { background-position: 200% 0; }
                    100% { background-position: -200% 0; }
                }

                .animate-shimmer {
                    animation: shimmer 3s linear infinite;
                }
            `}</style>
        </div>
    );
};

export default Statement;